<template>
    <b-row>
        <b-col>
            <b-form-group
                label="Parts of speech"
                label-for="GrammSpeechParts"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammSpeechParts" 
                        v-model="filter.gr.partOfSpeech" 
                        :options="partOfSpeech"/>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group
                label="Lexical classes"
                label-for="GrammLexicalClasses"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammLexicalClasses" 
                        v-model="filter.gr.lexicalClasses" 
                        :options="lexicalClasses"/>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group
                label="Attributivizers"
                label-for="GrammAttributivizers"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammAttributivizers" 
                        v-model="filter.gr.attributivizers" 
                        :options="attributivizers"/>
            </b-form-group>

            <b-form-group
                label="Numerals"
                label-for="GrammNumerals"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammNumerals" 
                        v-model="filter.gr.numerals" 
                        :options="numerals"/>
            </b-form-group>

            <b-form-group
                label="Number"
                label-for="GrammNumber"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammNumber" 
                        v-model="filter.gr.number" 
                        :options="number"/>
            </b-form-group>

        </b-col>

        <b-col>
        
            <b-form-group
                label="Core cases"
                label-for="GrammCoreCases"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammCoreCases" 
                        v-model="filter.gr.coreCases" 
                        :options="coreCases"/>
            </b-form-group>

        </b-col>

        <b-col>
            <b-form-group
                label="Spatial cases"
                label-for="GrammSpatialCases"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammSpatialCases" 
                        v-model="filter.gr.spatialCases" 
                        :options="spatialCases"/>
            </b-form-group>    

            <hr/>

            <b-form-group
                label="Spatial cases2"
                label-for="GrammSpatialCases2"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammSpatialCases2" 
                        v-model="filter.gr.spatialCases2" 
                        :options="spatialCases2"/>
            </b-form-group>
        </b-col>

        <b-col>
            <b-form-group
                label="Possessiveness"
                label-for="GrammPossessiveness"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammPossessiveness" 
                        v-model="filter.gr.possessiveness" 
                        :options="possessiveness"/>
            </b-form-group>
        </b-col>

        <b-col>
            <b-form-group
                label="Tense/Mood"
                label-for="GrammTense_Mood"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammTense_Mood" 
                        v-model="filter.gr.tense_mood" 
                        :options="tense_mood"/>
            </b-form-group>

            <b-form-group
                label="Verbal derivation"
                label-for="GrammVerbalDerivation"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammVerbalDerivation" 
                        v-model="filter.gr.verbalDerivation" 
                        :options="verbalDerivation"/>
            </b-form-group>
        </b-col>

        <b-col>
            <b-form-group
                label="Non-finite forms"
                label-for="GrammNonFiniteForms"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammNonFiniteForms" 
                        v-model="filter.gr.nonFiniteForms" 
                        :options="nonFiniteForms"/>
            </b-form-group>
        </b-col>

        <b-col>
            <b-form-group
                label="Imperatives"
                label-for="GrammImperatives"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammImperatives" 
                        v-model="filter.gr.imperatives" 
                        :options="imperatives"/>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: "udmgrammar",

    props: {
        filter: {
            type: Object,
            default: null
        }
    },

    data(){
        return {
            partOfSpeech: ['N','V','ADJ','ADV','PRED','NUM','PRO','POST','CNJ','PART','INTRJ','IMIT'],
            lexicalClasses: ['rel_n','PN','topn','persn','famn','patrn','anim','hum','supernat','transport','body','rel_adj','rus','oblin','I','II','tr','intr'],
            attributivizers: ['attr','attr_o','attr_em','attr_tem'],
            numerals: ['ord','period','coll'],
            number: ['sg','pl','person','1','2','3'],
            coreCases: ['nom','acc','gen','abl','dat','ins','car','adv'],
            spatialCases: ['loc','ill','el','egr','term','prol','app'],
            spatialCases2: ['obl','case_comp','dms'],
            possessiveness: ['1sg','1pl','2sg','2pl','3sg','3pl'],
            tense_mood: ['prs','fut','pst','evid','subj'],
            verbalDerivation: ['iter','caus','pass','mult','vn'],
            nonFiniteForms: ['inf','ptcp','ptcp,act','ptcp,pass','ptcp,res','cvb','cvb,gen','cvb,dur','cvb,lim','cvb,simult'],
            imperatives: ['imp','ptcp,act']
        }
    }
}
</script>